<template>
  <div class="page-wrapper">
    <div class="header">
      <headerComponent/>
    </div>
    <div class="main">
      <section>
        <h2>Privacy Policy</h2>
        <p>Effective Date:  11/12/2024</p>
        <p>Artemis Ads LLC ("we," "our," or "us", “the Affiliate Platform”, “the Platform”) is committed to protecting your data and privacy. This Privacy Policy describes how we collect, use, disclose, and safeguard your information when you visit our platform, which connects advertisers with affiliate publishers. Please read this policy carefully to understand our practices regarding your information.</p>
        <p>By logging into and using the Affiliate Platform, you acknowledge this Policy will apply to you and accept our Terms of Service</p>
      </section>
      <section>
        <h3>1. Information We Collect</h3>
        <ul>
          <li><b>Personal Information: </b>We may collect personal information such as your User ID, name, email address, phone number, company name, and any other details you provide to register and create an account, or communications you send through the Platform</li>
          <li><b>Usage Data: </b>We automatically collect certain information about your device and how you interact with our platform, including IP addresses, browser type, operating system, referring URLs, pages viewed, and the dates/times of visits, button clicks, navigation patterns.</li>
          <li><b>Cookies and Similar Technologies: </b>We use cookies, tracking pixels, and other similar technologies to collect information about your interactions with our platform and improve your experience. You may set your browser to refuse cookies; however, some features may be limited.</li>
          <li><b>Amazon Attribution data: </b>The core service we provide relies only on Amazon attribution data.Based on the terms of use, Artemis Ads LLC is authorized by Sellers to access their Amazon Attribution, create attribution links, and report the performance data related to the attribution links.We do not collect or receive consumer data from your connected Amazon account.</li>
          <li><b>Financial Data: </b>includes commission and payment records, bank account and payment card details that are used for the payment of membership fees, payment and receiving of commissions.</li>
          <li><b>Geolocation data: </b>General region or area where you access the Platform, derived in part from IP address.</li>
          <li><b>Marketing and Communications Data: </b>The rate, terms set up between sellers and publishers(creators), The communications between sellers and publisher(creator) at Artemis Ads LLC affiliate platform. Anything communicated to other users, including information or content uploaded using the Platform.</li>
        </ul>
      </section>
      <section>
        <h3>2. How We Use Your Information</h3>
        <p style="text-decoration: underline;">We do not sell or share personal information.</p>
        <p>We may use the information we collect for various purposes, including:</p>
        <ul>
          <li>To report performance for both advertisers and publishers</li>
          <li>To provide, maintain, and improve our platform.</li>
          <li>To connect advertisers and publishers for marketing and affiliate activities</li>
          <li>To manage user accounts, process payments, and facilitate transactions.</li>
          <li>To communicate with you regarding updates, offers, and security alerts.</li>
          <li>To work service providers, including but not limited to analytics providers like Google analytics, payment companies like Paypal, hosting services like AWS.</li>
          <li>To comply with applicable laws and regulations.</li>
          <li>To ensure compliance with applicable regulations and contractual obligations, particularly where sensitive data such as financial information is concerned.</li>
        </ul>
      </section>
      <section>
        <h3>3. Legal Bases for Processing (GDPR)</h3>
        <p>If you are located in the European Economic Area (EEA), we process your personal information under the following lawful bases:</p>
        <ul>
          <li><b>Consent: </b>Where you have given us explicit consent to use your data.</li>
          <li><b>Contractual Necessity: </b>For the performance of a contract, such as providing our services to you.</li>
          <li><b>Legitimate Interests: </b>To improve our platform and safeguard its security, in a way that is reasonable and not intrusive to you.</li>
          <li><b>Legal Obligation: </b>When required to comply with legal obligations, including data retention requirements under applicable laws.</li>
        </ul>
      </section>
      <section>
        <h3>4. Sharing Your Information</h3>
        <p>We may share your information with third parties under the following circumstances:</p>
        <ul>
          <li><b>Service Providers: </b>We may share your information with third-party service providers who perform functions on our behalf, such as payment processing, data analysis, email delivery, and customer service.</li>
          <li><b>Legal Requirements: </b>We may disclose your information if required by law or in response to valid requests by public authorities (e.g., a court or government agency).</li>
          <li><b>Business Transfers: </b>If we are involved in a merger, acquisition, or asset sale, your information may be transferred as part of that transaction.</li>
        </ul>
      </section>
      <section>
        <h3>5. Your Rights</h3>
        <p><b>Rights Under GDPR (EEA Residents)</b></p>
        <p>If you are located in the EEA, you have the right to:</p>
        <ul>
          <li>Access your personal information.</li>
          <li>Request correction or deletion of your personal information.</li>
          <li>Restrict or object to our processing of your personal information.</li>
          <li>Request data portability.</li>
          <li>Right to withdraw consent (withdrawing does not affect the lawfulness of processing based on consent before withdrawal)</li>
        </ul>
        <p>To exercise any of these rights, please contact us at: Support@ArtemisAds.com.</p>
        <p><b>Rights Under CCPA (California Residents) and certain U.S. States</b></p>
        <p>If you are a California resident, Colorado, Connecticut, Utah, Virginia or another state with a similar data-privacy law, you may have additional rights that you (or your authorized agent) can exercise by contacting us.</p>
        <p>You have the right to:</p>
        <ul>
          <li>Request details about the categories of personal information we collect and the sources from which we collect it.</li>
          <li>Request correction of deletion of your personal information.</li>
          <li>Opt-out of the "sale" of your personal information, if applicable.</li>
        </ul>
        <p>To exercise these rights, please submit a request by contacting us at: Support@ArtemisAds.com</p>
      </section>
      <section>
        <h3>6. Data Security</h3>
        <p>We implement industry-standard measures to protect your personal information from unauthorized access, disclosure, alteration, and destruction. However, please note that no security measures are completely infallible, and we cannot guarantee absolute security.</p>
        <p>We have put in place procedures to deal with any suspected personal data breach and will notify you and any applicable regulator of a breach where we are legally required to do so.</p>
      </section>
      <section>
        <h3>7. Data Retention</h3>
        <p>We retain personal information as long as necessary to fulfill the purposes outlined in this policy, unless otherwise required by law. When data is no longer needed, we will delete or anonymize it in a secure manner. You understand that in some cases, longer retention periods may be required to meet legal, tax, accounting, or regulatory obligations.</p>
        <p>When determining retention periods, we consider the type, amount, and sensitivity of the personal information, the potential risks associated with unauthorized use or disclosure, and whether we can fulfill the intended purpose without retaining the information longer.</p>
      </section>
      <section>
        <h3>8. International Data Transfers</h3>
        <p>For users in the EEA, your information may be transferred and processed outside the EEA in countries that may not have data protection laws equivalent to those in your jurisdiction. We take steps to ensure that adequate safeguards are in place, such as utilizing Standard Contractual Clauses.</p>
      </section>
      <section>
        <h3>9. Cookies and Tracking Technologies</h3>
        <p>Our platform uses cookies and similar tracking technologies to collect and use personal information. You may adjust your browser settings to refuse cookies; however, doing so may impact the functionality of our platform. For more information, see our Cookie Policy.</p>
      </section>
      <section>
        <h3>10. Changes to this Privacy Policy</h3>
        <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date. </p>
        <p>This Privacy Policy is current as of the effective date set forth above. Artemis Ads LLC reserves the right to change this privacy policy from time to time consistent with applicable privacy laws and principles. </p>
        <p>If we make changes to this Privacy Policy we will notify you by revising the date at the top of this Privacy Policy, and in some cases, we may provide you with additional notice (such as adding a statement to the homepages of our websites or sending you an e-mail notification). We also encourage you to review this policy periodically to stay informed about our data practices.</p>
        <p>While we will make reasonable attempts to notify you of updates, you acknowledge and agree that it is your responsibility to review the Effective date periodically and ensure you remain aware of the content of the Policy.</p>
      </section>
      <section>
        <h3>11. Contact Us</h3>
        <p>If you have any questions about this Privacy Policy, please contact us at:</p>
        <ul>
          <li><b>Email: </b><a>Support@ArtemisAds.com</a></li>
          <li>
            <b>Address:</b>
            Attention: Chief Privacy Manager<br/>
              Artemis Ads LLC<br/>
              740 E. Campbell Road, Suite 725, <br/>
              Richardson, TX 75230
          </li>
        </ul>
      </section>
    </div>
    <footerComponent/>
  </div>
</template>
<script setup>
  import footerComponent from '../home/footerComponent.vue';
  import headerComponent from '../home/headerComponent.vue';
</script>
<style lang="less" scoped>
  .page-wrapper {
    .header {
      background-color: #efeafc;
    }
    .main {
      // min-width: 900px;
      // width: 900px;
      // margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      // justify-content: center;
      padding-bottom: 50px;
      background-color: #fff;
      section {
        width: 900px;
        color: var(--dark-1);
        font-family: Sora, sans-serif;
        > h2 {
          font-size: 24px;
          padding-top: 50px;
          margin-bottom: 15px;
        }
        > h3 {
          font-size: 24px;
          margin-top: 20px;
          margin-bottom: 15px;
        }
        > h4 {
          font-size: 18px;
          margin-top: 20px;
          margin-bottom: 15px;
        }
        > ul {
          > li {
            font-size: 18px;
            line-height: 25px;
            margin-top: 10px;
            margin-bottom: 10px;
            > ul {
              > li {
                font-size: 18px;
                line-height: 25px;
                margin-top: 10px;
                margin-bottom: 10px;
              }
            }
          }
        }
        > p {
          font-weight: 400;
          font-size: 16px;
          letter-spacing: 0.4px;
          line-height: 24px;
          margin-top: 10px;
          margin-bottom: 20px;
        }
      }
    }
  }
</style>